import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Self, ViewChild } from '@angular/core';
import { WIPSearchModal } from '../new-submission/new-submission.component';
import { dropdown } from 'src/app/modal/DAO';
import { ServiceLayer } from 'src/app/services/serviceLayer';
import { NgForm } from '@angular/forms';
import { workInProgress } from 'src/app/modal/routing.models';
declare var jQuery: any;
import * as $ from "jquery";
import { SortEvent } from 'primeng/api';
import { ReassignSubmissionComponent } from './reassign-submission/reassign-submission.component';
import { AgentListService } from 'src/app/services/agentList.service';
import { Auth0UserService } from 'src/app/services/auth0UserService.service';

@Component({
  selector: 'work-in-progress-template',
  templateUrl: './work-in-progress-template.component.html',
  styleUrls: ['./work-in-progress-template.component.css']
})
export class WorkInProgressTemplateComponent implements OnInit {
  @ViewChild('searchForm') searchWIPForm: NgForm;
  @Input() workInProgressSearchModal: WIPSearchModal = new WIPSearchModal();
  @Input() workInProgressStatusDropdown: Array<dropdown> = new Array<dropdown>();
  @Input() workInProgressData: Array<workInProgress> = new Array<workInProgress>();
  @Input() hasNoWorkInProgressResults: boolean = false;
  @Input() isAgencyView: boolean = false;
  @Input() isEndorsementView: boolean = false;
  @Output() onSubmissionItemSelected = new EventEmitter<workInProgress>();
  @Output() onEndorsementItemSelected = new EventEmitter<workInProgress>();
  @Output() onSearchButtonClicked = new EventEmitter<boolean>();
  public isSubmitted: boolean = false;
  public isFormChanged: boolean = false;

  @ViewChild(ReassignSubmissionComponent) reassignUserComponent: ReassignSubmissionComponent;
  constructor(public serviceLayer: ServiceLayer, private el: ElementRef, public agentListService: AgentListService, public auth0UserService: Auth0UserService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.dateControlChange();
      this.searchWIPForm.form.valueChanges.subscribe(() => {
        this.isFormChanged = true;
      });
    }, 3000);
  }

  public numbersOnly(e): boolean {
    return this.serviceLayer.numbersOnly(e, 'WIPSearch');
  }

  //  change Date control with mask
  private dateControlChange(): void {
    var that = this;
    jQuery(this.el.nativeElement).find('#calendarIcon1').inputmask("mm/dd/yyyy", {
      isComplete: function (event) {
        var value = event.join('');
        if (jQuery(".p-datepicker-panel")[0] == undefined) {
          if (value != '' && !isNaN(new Date(value).getTime())) {
            var dobDate = value.replace('m', '0').replace('d', '0').replace('y', '0');
            if (that.workInProgressSearchModal.beginningEffectiveDate != new Date(dobDate)) {
              that.workInProgressSearchModal.beginningEffectiveDate = new Date(dobDate);
            }
          }
        }
      },
      onKeyValidation: function (key, result) {
        $("div").remove(".p-datepicker-panel");
      }
    });

    jQuery(this.el.nativeElement).find('#calendarIcon1').blur(function () {
      if (new Date(that.workInProgressSearchModal.beginningEffectiveDate) > that.workInProgressSearchModal.endingEffectiveDate) {
        that.workInProgressSearchModal.beginningEffectiveDate = that.workInProgressSearchModal.endingEffectiveDate;
      }
    })

    jQuery(this.el.nativeElement).find('#calendarIcon2').inputmask("mm/dd/yyyy", {
      isComplete: function (event) {
        var value = event.join('');
        if (jQuery(".p-datepicker-panel")[0] == undefined) {
          if (value != '' && !isNaN(new Date(value).getTime())) {
            var dobDate = value.replace('m', '0').replace('d', '0').replace('y', '0');
            if (that.workInProgressSearchModal.endingEffectiveDate != new Date(dobDate)) {
              that.workInProgressSearchModal.endingEffectiveDate = new Date(dobDate);
            }
          }
        }
      },
      onKeyValidation: function (key, result) {
        $("div").remove(".p-datepicker-panel");
      }
    });
    jQuery(this.el.nativeElement).find('#calendarIcon2').blur(function () {
      if (new Date(that.workInProgressSearchModal.endingEffectiveDate) < that.workInProgressSearchModal.beginningEffectiveDate) {
        that.workInProgressSearchModal.endingEffectiveDate = that.workInProgressSearchModal.beginningEffectiveDate;
      }
    })
  }

  public getWIPFilter(searchForm: NgForm): void {
    this.isFormChanged = false;
    if (searchForm.valid) {
      this.onSearchButtonClicked.emit(false);
    }
    this.isSubmitted = true;
  }

  public onRowSelect(event: workInProgress): void {
    this.onSubmissionItemSelected.emit(event);
  }

  public clickedInProgressEndorsement(event: workInProgress): void {
    if (event.status == "Incomplete") {
      this.onEndorsementItemSelected.emit(event);
    }
  }

  public resetWIPFilter(searchForm: NgForm): void {
    this.isFormChanged = false;
    this.workInProgressSearchModal = new WIPSearchModal();
    this.onSearchButtonClicked.emit(true);
    searchForm.resetForm();
    this.isSubmitted = false;
  }

  public customSort(event: SortEvent): void {
    event.data.sort((data1, data2) => {
      var field = (!this.isEndorsementView && event.field === 'submissionTimeStamp') ? 'modifiedDateTime' : event.field;
      const value1 = data1[field];
      const value2 = data2[field];
      let result = null;
      if (!!!value1 && !!!value2) result = 0;
      else if (!!!value1 && !!value2) result = event.order === 1 ? 1 : -1;
      else if (!!value1 && !!!value2) result = event.order === 1 ? -1 : 1;
      
      else if (event.field === 'dotNumber') {
        const number1 = Number(value1);
        const number2 = Number(value2);
        result = number1 < number2 ? -1 : number1 > number2 ? 1 : 0;
      }
      else if (event.field === 'submissionTimeStamp') {
        const dateKey = !this.isEndorsementView ? 'modifiedDateTime' : 'submissionTimeStamp'; 
        const parseToTime = (date: any ) : number => {
          if(!!!date) return 0;
          const parsedDate = new Date(date).getTime();
          return isNaN(parsedDate) ? 0 : parsedDate;
        } 
        const time1 = data1[dateKey] ? parseToTime(data1[dateKey]) : 0;
        const time2 = data2[dateKey] ? parseToTime(data2[dateKey]) : 0;
        result = time1 < time2 ? -1 : time1 > time2 ? 1 : 0;
      }
      else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      
      return event.order * result; 
    });
  }

  public popUpReassignDialog(item: workInProgress): void {
    if (item != null) {
      this.agentListService.shallDiplayReassignDialog.set(true);
      // Set child component data via @ViewChild reference
      this.reassignUserComponent.curWorkInProgress.set(item);
    }
  }

  public closeReassignDialog(): void {
    if(this.agentListService.submissionReassigned()) {
      this.serviceLayer.getWorkInProgress();
      this.serviceLayer.GetAgencyWIPData();
    }
    this.agentListService.submissionReassigned.set(false);
    this.reassignUserComponent.reAssignSubmissionForm.resetForm();
    this.reassignUserComponent.displayResponseMessage.set("");
  }
}
